import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Firebase web configuration, resolved per environment at build time.
// Values come from REACT_APP_FIREBASE_* (e.g. .env for production, .env.staging
// for the staging project); the production values are fallbacks so a build
// without env vars behaves exactly as before. `||` (not `??`) so an
// empty-string env var also falls back rather than shipping a blank config.
// Static process.env.X accesses only — bundlers inline these at build time.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyDDYJ7z26LaGT_s-rjjnIrYzj24f4jleqc',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'modulai-lead-agent.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'modulai-lead-agent',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'modulai-lead-agent.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '701644986039',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:701644986039:web:9377ccf554e55e3c935f32',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-M9FQ30269Q',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Connect to the local Firebase Emulator Suite when REACT_APP_USE_EMULATORS=true.
// Data services (Firestore/Storage/Functions) stay on localhost — no production
// data is touched. Auth is intentionally NOT emulated: the app uses real Firebase
// Auth so the normal Google sign-in works, and the Firestore emulator accepts the
// real ID token for its rules. Run `npm run start:emulated` (and `npm run emulators`
// in another terminal). See EMULATORS.md for prerequisites and usage.
const useEmulators = process.env.REACT_APP_USE_EMULATORS === 'true';

if (useEmulators) {
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectStorageEmulator(storage, 'localhost', 9199);
  connectFunctionsEmulator(functions, 'localhost', 5001);
  // eslint-disable-next-line no-console
  console.info('🔧 Firebase data services connected to the local Emulator Suite (auth uses prod)');
}

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('profile');
googleProvider.addScope('email');

// Initialize Analytics (skipped under emulators — no real measurement target locally)
export const analytics =
  typeof window !== 'undefined' && !useEmulators ? getAnalytics(app) : null;

export default app;